module.exports = __webpack_public_path__ + "img/project-management.af629ea2.png";